import { AGENT } from '@/api'
import { uiHelper } from '@/utils'

/* Define Module Name */
const MODULE_NAME = 'agent/'

/* Define Action Name */
const A_GET_AGENT_APPLICATION_STATUS = 'getAgentApplicationStatus'
const A_GET_AGENT_STATUS = 'getAgentStatus'
const A_GET_AGENT_TRANSACTION = 'getAgentTransaction'
const A_GET_AGENT_TEAM = 'getAgentTeam'
const A_APPLY_AS_AGENT = 'applyAsAgent'
const A_GET_MEMBER_TRANSACTION = 'getMemberTransaction'
const A_GET_BANK_LIST = 'getBankList'
const A_TRANSFER_TO_BANK = 'transferToBank'
const A_CONVERT_POINT = 'convertPoint'
const A_AGENT_TNC_AGREEMENT = 'sendTncAgreement'
const A_GET_USER_WITHDRAWAL_BANKS = 'getUserWithdrawalBanks'
const A_ADD_USER_WITHDRAWAL_BANK = 'addUserWithdrawalBank'
const A_DELETE_USER_WITHDRAWAL_BANK = 'deleteUserWithdrawalBank'
const A_DOWNLOAD_TRANSACTION_HISTORY_PDF = 'downloadTransactionHistoryFile'

/* Define Getter Name */

/* Define Mutation Name */
const M_SET_CURRENT_AGENT = 'setCurrentAgent'
const M_SAVE_AGENT_FORM = 'saveAgentForm'
const M_SET_AGENT_APPLICATION_STATUS = 'setAgentApplicationStatus'
const M_SET_AGENT_TNC_STATUS = 'setAgentTncStatus'

const state = {
  currentAgent: null,
  agentForm: {},
  isPendingAgentTnc: false,
  agentApplicationStatus: null
}

//Getters
const getters = {}

// Actions
const actions = {
  async [A_GET_AGENT_APPLICATION_STATUS]({ commit }) {
    return await AGENT.getApplicationStatus().then((res) => {
      commit(M_SET_AGENT_APPLICATION_STATUS, res)
      if (res.tnc_status === 'Pending') commit(M_SET_AGENT_TNC_STATUS, true)
      else commit(M_SET_AGENT_TNC_STATUS, false)
    })
  },
  async [A_GET_AGENT_STATUS]({ commit }) {
    return await AGENT.getStatus().then((res) => {
      console.log('FETCH AGENT STATUS')
      commit(M_SET_CURRENT_AGENT, res)
    })
  },
  async [A_GET_AGENT_TRANSACTION]({ commit }, data) {
    return await AGENT.getTransactionHistory(data)
  },
  async [A_GET_AGENT_TEAM]({ commit }, data) {
    return await AGENT.getAgentTeam(data)
  },
  async [A_APPLY_AS_AGENT]({ state }) {
    return await AGENT.applyAsAgent(state.agentForm)
  },
  async [A_AGENT_TNC_AGREEMENT](_, data) {
    return await AGENT.tncAgreement(data)
  },
  async [A_GET_MEMBER_TRANSACTION](_, data) {
    return await AGENT.getMemberTransaction(data)
  },
  async [A_GET_BANK_LIST](_, data) {
    return await AGENT.getBankList()
  },
  async [A_TRANSFER_TO_BANK](_, data) {
    return await AGENT.transferToBank(data)
  },
  async [A_CONVERT_POINT](_, data) {
    return await AGENT.convertPoint(data)
  },
  async [A_GET_USER_WITHDRAWAL_BANKS]() {
    return await AGENT.getUserWithdrawBankList()
  },
  async [A_ADD_USER_WITHDRAWAL_BANK](_, data) {
    return await AGENT.addUserWithdrawalBank(data)
  },
  async [A_DELETE_USER_WITHDRAWAL_BANK](_, id) {
    return await AGENT.deleteUserWithdrawalBank(id)
  },
  async [A_DOWNLOAD_TRANSACTION_HISTORY_PDF](_, data) {
    return await AGENT.downloadTransactionPDF(data)
  }
}

// Mutations
const mutations = {
  [M_SET_CURRENT_AGENT](state, data) {
    state.currentAgent = data
  },
  [M_SAVE_AGENT_FORM]: (state, form) => {
    state.agentForm = { ...state.agentForm, ...form }
  },
  [M_SET_AGENT_APPLICATION_STATUS]: (state, data) => {
    state.agentApplicationStatus = data
  },
  [M_SET_AGENT_TNC_STATUS]: (state, data) => {
    state.isPendingAgentTnc = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
